import { render } from "./TyreAd.vue?vue&type=template&id=13adfd60"
import script from "./TyreAd.vue?vue&type=script&lang=js"
export * from "./TyreAd.vue?vue&type=script&lang=js"

import exportComponent from "/Users/chrismains/Sites/fixmycar/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__